import { render, staticRenderFns } from "./feelingInfo.vue?vue&type=template&id=223e0fc2&scoped=true&"
import script from "./feelingInfo.vue?vue&type=script&lang=js&"
export * from "./feelingInfo.vue?vue&type=script&lang=js&"
import style0 from "./feelingInfo.vue?vue&type=style&index=0&id=223e0fc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e0fc2",
  null
  
)

export default component.exports